import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from "../../assets/img/logo.png";
import { VscEyeClosed, VscEye } from 'react-icons/vsc';
import { MdError, MdClose } from 'react-icons/md';
import { userLoginAction } from "../../redux/actions/userActions";

const Login = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [passwordVisible, setPasswordVisible] = useState(false)
  const [showToast, setShowToast] = useState(false)

  // --- Login States --- //
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo, loading, error } = userLogin

  useEffect(() => {
    if(userInfo) {
      navigate("/dashboard")
    }
    if(error) {
      setShowToast(true)
    }
    if(loading) {
      setShowToast(false)
    }
  }, [userInfo, error, loading])

  const handleLoginUser = (e) => {
    e.preventDefault()
    dispatch(userLoginAction(username, password))
  }

  return (
    <div id="login">
      <div className="container">
        <NavLink to="/" className="logo-area">
          <img src={logo} alt="Island Luxury" />
        </NavLink>
        <div className="login-form_cont">
          <h1>Login</h1>
          <form onSubmit={handleLoginUser}>
            <div className="form-grp">
              <label htmlFor="username">Username</label>
              <input 
                type="text" 
                id="username" 
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="password">Password</label>
              <input 
                type={passwordVisible ? "text" : "password"} 
                id="password" 
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)} />
              <div className="password-visibility" onClick={() => setPasswordVisible(!passwordVisible)}>
                {passwordVisible ? <VscEye /> : <VscEyeClosed />}
              </div>
            </div>
            <button type="submit" disabled={loading && true}>{loading ? "Signing in..." : "Sign in"}</button>
            {showToast &&
              <div className="msg-toast error">
                <div>
                  <MdError size={20} />
                  <p>{error}</p>
                </div>
                <span onClick={() => setShowToast(false)}><MdClose size={20} /></span>
              </div>
            }
          </form>
          <div>
            <p>New to Island Luxury? <NavLink to="/signup">Create an account</NavLink></p>
            {/* <p>Forgot password? <NavLink to="/">Reset password</NavLink></p> */}
          </div>
        </div>
        <div className="login-footer">
          <NavLink to="/terms">Terms</NavLink> |
          <NavLink to="/terms"> Privacy</NavLink> |
          <NavLink to="/contact"> Contact</NavLink>
        </div>
      </div>
    </div>
  )
}

export default Login;